import { IWorkflowJob, IWorkflowService } from 'interfaces-lib';
import { Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { SocketManager } from 'web-socket-manager-service-lib';
import { WorkflowTask } from './workflow-task';

export class WorkflowTaskRunner {
  private workflowService: IWorkflowService;
  private workflowTask: WorkflowTask;
  private readonly _socketManager: SocketManager<any>;

  constructor(workflowService: IWorkflowService, workflowTask: WorkflowTask) {
    this.workflowService = workflowService;
    this.workflowTask = workflowTask;
    this._socketManager = new SocketManager<any>();
  }

  run(): Observable<void> {
    return this.workflowService.start(this.workflowTask.workflowName, this.workflowTask.getStartParams()).pipe(
      tap((workflowJob) => {
        this.openSocket(workflowJob);
        this.workflowTask.workflowStartSuccess();
      }),
      map((_) => undefined),
      catchError((error) => {
        throw error;
      })
    );
  }

  private openSocket(workflowJob: IWorkflowJob): void {
    console.log('startWorkflow job', this.workflowService.workflowStatusUrl, workflowJob);
    const wssUrl = `${this.workflowService.workflowStatusUrl}/workflow/${workflowJob.workflowName}/${workflowJob.id}`;
    const socketMessage$ = this._socketManager.open(workflowJob.id, wssUrl);
    const subscription = socketMessage$.subscribe(
      (message) => this.socketMessage(message),
      (error) => this.socketError(error),
      () => {
        subscription.unsubscribe();
      }
    );
  }

  private socketMessage(data: any): void {
    let closeConnection;

    try {
      closeConnection = this.workflowTask.receive(data);
    } catch (e) {
      console.error('Error forwarding message. Forcing socket close.', e);
      closeConnection = true;
    }

    if (closeConnection) {
      console.log(`Closing socket on '${data.type}' message`);
      this._socketManager.close(data.socketId);
    }
  }

  private socketError(error: any): void {
    // whenever a socket is closed (even cleanly) it throws an ABNORMAL_CLOSURE error
    const ABNORMAL_CLOSURE = 1006;
    if (error.code !== ABNORMAL_CLOSURE) {
      console.log('socket error', error);
      this.socketMessage({ type: 'ErrorEvent', message: error.reason });
    }
  }
}
